module.exports = __webpack_public_path__ + "static/logo-blue-lemonade-3168eb4c4eaf9cebc2ed1f593a2dfd89.png";